import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OutputFormat } from '@core/models';
import { RelatorioSelectOption } from '../../relatorios.models';
import { Select } from 'primeng/select';


@Component({
  selector: 'app-report-general-filters',
  standalone: true,
  imports: [FormsModule, Select],
  templateUrl: './report-general-filters.component.html',
  styleUrl: './report-general-filters.component.scss',
})
export class ReportGeneralFiltersComponent {
  @Input({ required: true }) periods: RelatorioSelectOption[] = [];
  @Input({ required: true }) clients: RelatorioSelectOption[] = [];
  @Input({ required: true }) posts: RelatorioSelectOption[] = [];
  @Input({ required: true }) formats: RelatorioSelectOption[] = [];

  @Input() selectedPeriod = 1;
  @Input() selectedClient: string | number | null = null;
  @Input() selectedPost: string | number | null = null;
  @Input() selectedFormat: OutputFormat = 'pdf';
  @Input() loadingClients = false;
  @Input() loadingPosts = false;

  @Output() selectedPeriodChange = new EventEmitter<number>();
  @Output() selectedClientChange = new EventEmitter<string | number | null>();
  @Output() selectedPostChange = new EventEmitter<string | number | null>();
  @Output() selectedFormatChange = new EventEmitter<OutputFormat>();
}